import React from "react";

import Assess from "../../pages/components/assess";

import "../../assets/css/assessment-theme.css";
import "../../styles/sme-assess-panel.css";

export type SmeAssessTabProps = {
  assessUser: { project: unknown; userId: number | string } | null;
  projectId: number | string | null;
  clientUserId: number | string | null;
  isTabActive: boolean;
};

/**
 * SME read-only assessment review — no assessment.css (avoids re-importing legacy dashboard-theme).
 */
export function SmeAssessTab({
  assessUser,
  projectId,
  clientUserId,
  isTabActive,
}: SmeAssessTabProps) {
  if (!assessUser || !projectId || !clientUserId) {
    return (
      <p className="sme-assess-panel__empty">Select a project to review assessment responses.</p>
    );
  }

  return (
    <div className="sme-assess-panel">
      <Assess
        key={`assess-${projectId}-${clientUserId}`}
        embedded
        isTabActive={isTabActive}
        user={assessUser}
      />
    </div>
  );
}

export default SmeAssessTab;
